<template>
  <div class="app-product-aid-intro">
    <div class="app-product-aid-intro__image-container">
      <NuxtImg
        :src="introImage"
        :alt="t('marketingPages.productAid.intro.introImageAlt')"
        provider="storyblok"
        :height="getImageDimensionsFromStoryblokSrc(introImage).height"
        :width="getImageDimensionsFromStoryblokSrc(introImage).width"
      />
    </div>

    <div class="flex justify-center">
      <TappButton class="app-product-aid-intro__button" @click="emit('start')">
        {{ t('marketingPages.productAid.intro.startButton') }}
      </TappButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();

  defineProps<{
    introImage: string;
  }>();

  const emit = defineEmits<{
    start: [];
  }>();
</script>

<style lang="postcss" scoped>
  .app-product-aid-intro {
    display: grid;
    grid-template-rows: 1fr auto;
    flex: 1;
    gap: var(--spacing-6);

    padding: var(--spacing-2);
    border-radius: var(--spacing-1);

    &__image-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
